import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { MessagingService } from 'src/app/core/services/messaging.service';
import { PedidoPdf } from '../../pedido/models/pedido-pdf';
import { PedidoProdutoPdf } from '../../pedido/models/pedido-produto-pdf';
import { PedidoService } from '../../pedido/pedido.service';
import { ParametrizacaoService } from '../../parametrizacao/parametrizacao.service';
import { Parametro } from '../../parametrizacao/models/parametrizacao';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import htmlToPdfmake from 'html-to-pdfmake';

@Component({
  selector: 'app-evento-pedido-pdf',
  templateUrl: './evento-pedido-pdf.component.html',
  styleUrls: ['./evento-pedido-pdf.component.scss']
})
export class EventoPedidoPdfComponent implements OnInit, AfterViewInit  {

  private idPedido: string = "0";
  public itemPedido: PedidoPdf;
  public listaProduto: PedidoProdutoPdf[] = [];
  public parcelas: Date[];
  cols: any[];

  parametros: Parametro[];

  constructor(public pedidoService: PedidoService, private router: Router, private route: ActivatedRoute, private activateRoute: ActivatedRoute,
    private parametrizacaoService: ParametrizacaoService,
    private mailService: MessagingService) { }

  title = 'SIGEVE - Impressão do Pedido';

  ngOnInit(): void {

    this.idPedido = this.route.snapshot.paramMap.get("id");    
    this.itemPedido = this.activateRoute.snapshot.data['PedidoPdf'];
    this.getPedidoListaProduto(this.idPedido);
    this.cols = [
 
      { field: 'nomeProduto', header: 'Produto' },
      { field: 'quantidade', header: 'Quantidade' },
      { field: 'vlUnitario', header: 'Valor Unitário' },
      { field: 'vlTotal', header: 'Valor Total' }
  ];

  this.getParametrosEvento();

  
  }

  ngAfterViewInit(){
    if(this.router.url.includes('auto')){
      this.printPDFAndRedirect();
      
    }
  }


  async getParametrosEvento() {

    

    await this.parametrizacaoService.getParametrosEvento(Number.parseInt( this.itemPedido.idEvento)).subscribe(
      (res) => {
        if (res) {
          this.parametros = res;  
          console.log(res);     
        }
      },
      err => {
        console.log("EventoPedidoDetalhe - Parametros");
        console.log(err);
      }
    );
  } 


  getParametro(nomeParametro: string){
    return this.parametros?.filter(k => k?.nome?.toLowerCase()==nomeParametro.toLowerCase()).map(m=> m.valor)[0];
  }

  numSequence(n: number): Array<number> {
    return Array(n);
    
  }

  calcularParcelas(){
    this.parcelas=[];
    this.parcelas.push(this.itemPedido.dtPrimeiraParcela)

    for(let i=1;i<this.itemPedido.qtdParcelas;i++){
      
      let data:Date= new Date(this.itemPedido.dtPrimeiraParcela);
      let data2:Date= new Date(this.itemPedido.dtPrimeiraParcela);
      data2.setMonth(data2.getMonth()+i);

     
      if((((data.getMonth()+i)%12)+1)==2 ){
        if(data2.getFullYear()%4!==0){
          if(data.getDate()>28){
            data.setDate(28)
          }
        }else{
          if(data.getDate()>29){
            data.setDate(29)
          }
        }
      }

      if((((data.getMonth()+i)%12)+1)==4 ||(((data.getMonth()+i)%12)+1)==6 || (((data.getMonth()+i)%12)+1)==9 ||(((data.getMonth()+i)%12)+1)==11){
        
          if(data.getDate()>30){
            data.setDate(30)
          }
        
      }
      data.setMonth(data.getMonth()+i);
      this.parcelas.push(data)
    }

  }

 
  generatePDF() {

    var data = document.getElementById('contentToConvert');
    let pdf = new jsPDF('p', 'mm', 'a4',true);
    const TAMANHO_MAX = 2500
    const TAMANHO = 2350

   console.log(data.clientHeight )
    if(data.clientHeight>TAMANHO_MAX){
    
    html2canvas(data,{width:1799,height:TAMANHO,windowWidth: 1799,  scrollY: 0}).then(canvas => {
      var imgWidth = 208;
      var imgHeight = 280;//canvas.height * imgWidth / canvas.width;
      const contentDataURL = canvas.toDataURL('image/png')
      var position = 0;
      pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight,'','FAST')
      if(data.clientHeight <= TAMANHO){
        pdf.save('SIGEVE_Pedido_' + this.idPedido + '.pdf');
    }
      
    }).finally(() =>{

      if(data.clientHeight > TAMANHO)

      html2canvas(data,{width:1799,height:TAMANHO,windowWidth: 1799,  scrollY: -TAMANHO}).then(canvas => {
        var imgWidth = 208;

        var imgHeight = 280;//canvas.height * imgWidth / canvas.width;
        const contentDataURL = canvas.toDataURL('image/png')
        var position = 10;
      pdf.addPage();
      pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight,'','FAST')

      pdf.save('SIGEVE_Pedido_' + this.idPedido + '.pdf');
      
    });
    })

  }else{
    html2canvas(data,{width:1799,height:TAMANHO_MAX,windowWidth: 1799,  scrollY: 0}).then(canvas => {
      var imgWidth = 208;
      var imgHeight = 280;//canvas.height * imgWidth / canvas.width;
      const contentDataURL = canvas.toDataURL('image/png')
      var position = 0;
      pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight,'','FAST')
      pdf.save('SIGEVE_Pedido_' + this.idPedido + '.pdf');

    })
  }
    
    /*html2canvas(data,{width:1680,height:1983,windowWidth: 1799,  scrollY: 0}).then(canvas => {
      var imgWidth = 208;
      var imgHeight = 245;//canvas.height * imgWidth / canvas.width;
      const contentDataURL = canvas.toDataURL('image/png')
      let pdf = new jsPDF('p', 'mm', 'a4', true);
      var position = 0;
      pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight,'','FAST')
      pdf.save('SIGEVE_Pedido_' + this.idPedido + '.pdf');
    });*/
  }

  generatePDFOld() {

    var data = document.getElementById('contentToConvert');
    
    html2canvas(data,{width:1688,height:1890,windowWidth: 1799, windowHeight:1983, scrollY: 0, scrollX:0}).then(canvas => {
      var imgWidth = 208;
      var imgHeight = canvas.height * imgWidth / canvas.width;
      const contentDataURL = canvas.toDataURL('image/png')
      let pdf = new jsPDF('p', 'mm', 'a4');
      var position = 0;
      pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight)
      pdf.save('SIGEVE_Pedido_' + this.idPedido + '.pdf');
    });
  }

  printPDF() {

    var data = document.getElementById('contentToConvert');
    let pdf = new jsPDF('p', 'mm', 'a4',true);
    const TAMANHO_MAX = 2500
    const TAMANHO = 2350

   console.log(data.clientHeight )

   /*var html = htmlToPdfmake(data.innerHTML);

    let documentDefinition = { content: html } as any;

    documentDefinition.pageSize ='A2';

    pdfMake.createPdf(documentDefinition).open();
    return
    */
    if(data.clientHeight>TAMANHO_MAX){
    html2canvas(data,{width:1799,height:TAMANHO,windowWidth: 1799,  scrollY: 0}).then(canvas => {

      
      var imgWidth = 208;
      var imgHeight = 280;//canvas.height * imgWidth / canvas.width;
      const contentDataURL = canvas.toDataURL('image/png')
      var position = 0;
      pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight,'','FAST')
      if(data.clientHeight <= TAMANHO){
      var blob = pdf.output("blob");
      var file = new File([blob], 'SIGEVE_Pedido_' + this.idPedido + '.pdf');
    window.open(URL.createObjectURL(blob), '_blank');
    }
      
    }).finally(() =>{

      if(data.clientHeight > TAMANHO)

      html2canvas(data,{width:1799,height:2500,windowWidth: 1799,  scrollY:-300,scrollX:0 ,allowTaint: true,

        useCORS: true}).then(canvas => {
        canvas.scrollBy(0,-2000) ;
        var imgWidth = 208;

        var imgHeight = 280;//canvas.height * imgWidth / canvas.width;
        const contentDataURL = canvas.toDataURL('image/png')
        var position = 0;
        console.log(canvas)
      pdf.addPage();
      pdf.addImage(contentDataURL, 'PNG', 0, 0, imgWidth, imgHeight,'','FAST')


      

      /*this.mailService.sendEmail(file).subscribe(
        (res) => {
          if (res) {
           console.log(res)
            
          }
        },
        err => {
          console.log("ERRO PDF-PEDIDO: " + err);
        }
      );*/
      var blob = pdf.output("blob");
      var file = new File([blob], 'SIGEVE_Pedido_' + this.idPedido + '.pdf');
    window.open(URL.createObjectURL(blob), '_blank');
      
    });
    })

  }else{
    html2canvas(data,{width:1799,height:TAMANHO_MAX,windowWidth: 1799,  scrollY: 0}).then(canvas => {
      var imgWidth = 208;
      var imgHeight = 280;//canvas.height * imgWidth / canvas.width;
      const contentDataURL = canvas.toDataURL('image/png')
      var position = 0;
      pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight,'','FAST')

      var blob = pdf.output("blob");
      var file = new File([blob], 'SIGEVE_Pedido_' + this.idPedido + '.pdf');
    window.open(URL.createObjectURL(blob), '_blank');

      
    })
  }

    

    
  
  }

  printPDFAndRedirect() {

    var data = document.getElementById('contentToConvert');
    
    html2canvas(data).then(canvas => {
      var imgWidth = 208;
      var imgHeight = canvas.height * imgWidth / canvas.width;
      const contentDataURL = canvas.toDataURL('image/png')
      let pdf = new jsPDF('p', 'mm', 'a4',true);
      var position = 0;
      pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight,'','FAST')
      var blob = pdf.output("blob");
      var file = new File([blob], 'SIGEVE_Pedido_' + this.idPedido + '.pdf');


    window.open(URL.createObjectURL(blob), '_blank');
    this.router.navigate(['/'])
    });
  }

  public blobToFile = (theBlob: Blob, fileName:string): File => {
    var b: any = theBlob;
    //A Blob() is almost a File() - it's just missing the two properties below which we will add
    b.lastModifiedDate = new Date();
    b.name = fileName;

    //Cast to a File() type
    return <File>theBlob;
}

  getPedido(idPedido) {

    this.pedidoService.getPedidoEventoPdf(idPedido).subscribe(
      (res) => {
        if (res) {
          this.itemPedido = res;
          
        }
      },
      err => {
        console.log("ERRO PDF-PEDIDO: " + err);
      }
    );
  }

  getPedidoListaProduto(idPedido) {

    this.pedidoService.getPedidoProdutoEventoPdfLista(idPedido).subscribe(
      (res) => {
        if (res) {
          this.listaProduto = res;
          if(this.itemPedido.flParcelado){
            this.calcularParcelas();
          }
        }
      },
      err => {
        console.log("ERRO PDF-PEDIDO-PRODUTO: " + err);
      }
    );
  }

  BackPedidoClick(idPedido: string) {
    this.router.navigate(['/pedido', idPedido])
  }
}
